import { render, staticRenderFns } from "./compression-data.vue?vue&type=template&id=afdae4d4&scoped=true"
import script from "./compression-data.vue?vue&type=script&lang=js"
export * from "./compression-data.vue?vue&type=script&lang=js"
import style0 from "./compression-data.vue?vue&type=style&index=0&id=afdae4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdae4d4",
  null
  
)

export default component.exports